import type { LogEntry, StructuredLogger, ProgressEntry } from '@mimir/primitive/structuredLogger';

export type ProgressEntryHandler = (progress: ProgressEntry) => void;

export class ProgressPropagatingLogger implements StructuredLogger {
  private handlers: Record<string, ProgressEntryHandler> = { };

  constructor(private inner?: StructuredLogger) { }

  addHandler(entryId: string, progressHandler: ProgressEntryHandler) {
    this.handlers[entryId] = progressHandler;
  }

  log(entry: LogEntry): void {
    if (entry.progress !== undefined) {
      for (const entryId in entry.progress) {
        const handler = this.handlers[entryId];
        if (handler === undefined) {
          continue;
        }
        if (entry.progress[entryId]) {
          handler(entry.progress[entryId]);
        }
      }
    } else {
      this.inner?.log(entry);
    }
  }

  async close(): Promise<void> { }
}

